require('../scss/news.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');
require('../scss/utils/swiper/swiper.min.css');
var mock = require('mockjs');
var $ = require('jquery');
var common = require('./common');
var querystring = require('querystring');
var displayType = '';
var newsNav = '';
var lang = '';
var more = '';
var commonApi = require('../commonApi'); 
var utils = require('../utils')
var minioUrl = commonApi.api.minioUrl;
var formatNoneOssUrl = utils.formatNoneOssUrl

$(document).ready(function () {
    lang = common.initChangePage();
    if (lang == 'en') {
        more = 'MORE';
    } else {
        more = '了解更多';
    }

    $('#news').addClass('active');
    var query = querystring.parse(window.location.search.slice(1));
    if (query.displayType == undefined) {
        query = {
            displayType: 'img',
            nav: 'mediaNav',
        };
    }

    displayType = query.displayType;
    if (query.displayType == 'list') {
        changeNewsBox($('.list-CB'), query.nav, true);
    } else {
        changeNewsBox($('.img-CB'), query.nav, true);
    }

    $('.navta').click(function () {
        changeNewsNav($(this));
    });

  //模式切换
    $('.dis-icon').click(function () {
        changeNewsBox($(this), 'mediaNav', query.displayType === 'img');
    });
  //搜索
    $('#submitBtn').click(function () {
    //搜索的时候将当前的page的值切换为第一页
        pageNo = 0;
        getArticlesList();
    });

    $('#search').keydown(function (event) {
        var key_num = event.keyCode;
        if (13 == key_num) {
            pageNo = 0;
            getArticlesList();
        }
    });
});

//新闻显示格式
//img-icon 图文显示格式
//list-icon 新闻列表显示格式
function changeNewsBox($e, nav, isFirst) {
    var objActive = $e.parents('.dis-type').find('.active');
    if (objActive.length == 0) {
    //初始化
        if (displayType == 'img') {
            $e.removeClass('img-CB').addClass('img-CBS active');
            $('#img-news-box').show();
            $('#list-news-box').hide();
        } else {
            $e.removeClass('list-CB').addClass('list-CBS active');
            $('#img-news-box').hide();
            $('#list-news-box').show();
        }
    } else {
        if ($e.is(objActive)) {
            return;
        } else {
            if (objActive.hasClass('img-icon')) {
                objActive.removeClass('active img-CBS').addClass('img-CB');
                $e.removeClass('list-CB').addClass('list-CBS active');
                $('#img-news-box').hide();
                $('#list-news-box').show();
                displayType = 'list';
            } else {
                objActive.removeClass('active list-CBS').addClass('list-CB');
                $e.removeClass('img-CB').addClass('img-CBS active');
                $('#img-news-box').show();
                $('#list-news-box').hide();
                displayType = 'img';
            }
        }
    }
  // if (!isFirst) {
    changeNewsNav($('#' + nav + ''), isFirst);
  // }
}

//图文模式 报道类型跳转
var $root = $('html, body');

function changeNewsNav($e, isFirst) {
    var href = $e.attr('href');
    var navT = $e.parents('.nav-two');
    navT.find('.active').removeClass('active');
    newsNav = $e.attr('id');
  //now selected nav
    $e.parent('.navt').addClass('active');
    if (displayType == 'list') {
        var state = {
            displayType: 'list',
            nav: 'newsNav',
        };
        window.history.pushState(
      state,
      'My Profile',
      '/news?displayType=list&nav=mediaNav'
    );
        getArticlesList('123');
    } else {
        getClassifiedArticles();
        window.history.pushState(
      state,
      'My Profile',
      '/news?displayType=img&nav=mediaNav'
    );
        if (!isFirst) {
            $root.animate(
                {
                    scrollTop: $(href).offset().top,
                },
        1000,
        function () {
          // window.location.hash = href;
        }
      );
        }
        return false;
    }
}

var mediaArticles = [];
var transactionArticles = [];
var companyArticles = [];
var activityArticles = [];
var partyArticles = [];

//新闻 图文模块请求
function getClassifiedArticles() {
    var api = common.getAPI();

    $.ajax({
        url: api + 'v1/china/article/type',
        type: 'get',
        dataType: 'json',
    //      dataType: 'text',
        data: {
            lang: lang === 'en' ? 'en' : 'zh',
        },
        success: function (data) {
      //			if((typeof data)=='string'){
      //				console.log("string")
      //				data = eval('(' + data + ')');
      //			}
      //			data = mock.mock(data)
      //			console.log(data)
            if (data.status) {
                var pageSize = 3;
                var str = '';
                mediaArticles = data['news-reports'] || [];
                if (mediaArticles.length > 0) {
                    str = getInnerStr(mediaArticles.length, pageSize);
                    $('.media-inner').html(str);
                    setArticles('mediaArticles', 0);
                }

                companyArticles = data['company-news'] || [];
                if (companyArticles.length > 0) {
                    str = getInnerStr(companyArticles.length, pageSize);
                    $('.company-inner').html(str);
                    setArticles('companyArticles', 0);
                }

                activityArticles = data['events'] || [];
                if (activityArticles.length > 0) {
                    str = getInnerStr(activityArticles.length, pageSize);
                    $('.activity-inner').html(str);
                    setArticles('activityArticles', 0);
                }

                transactionArticles = data['transactions'] || [];
                if (transactionArticles.length > 0) {
                    str = getInnerStr(transactionArticles.length, pageSize);
                    $('.transaction-inner').html(str);
                    setArticles('transactionArticles', 0);
                }
                

                partyArticles = data['party-building-section'] || [];
                if (partyArticles.length > 0) {
                    str = getInnerStr(partyArticles.length, pageSize);
                    $('.company-inner').html(str);
                    setArticles('partyArticles', 0);
                }

        // if(transactionArticles.length > 0) {
        // 	pageSize = 6;
        // 	str = getInnerStr(transactionArticles.length, pageSize);
        // 	$('.transaction-inner').html(str);
        // 	setArticles('transactionArticles', 0);
        // }
            }
        },
        error: function (msg) {
            console.log(msg);
        },
    });
}

function change2Array(data, len, arr) {
  /**
   * @param data 一维数组
   * @param len 每个子数组长度
   * @param arr 保存的新数组
   */
    if (data.length <= len) {
        arr.push(data);
        return arr;
    } else {
        arr.push(data.splice(0, len));
        change2Array(data, len, arr);
    }
}

//页面数据渲染
function setArticles(category, index) {
    var mySwiper = new Swiper('#media-box .swiper', {
    // 如果需要分页器
        pagination: {
            el: '#media-box .swiper-pagination',
            clickable: true,
            bulletClass: 'my-bullet',//需设置.my-bullet样式
            bulletActiveClass: 'my-bullet-active',
        },
    // 如果需要前进后退按钮
        navigation: {
            nextEl: '#media-box .swiper-button-next',
            prevEl: '#media-box .swiper-button-prev',
        },
    });
    var mySwiper1 = new Swiper('#transaction-box .swiper', {
    // 如果需要分页器
        pagination: {
            el: '#transaction-swiper .swiper-pagination',
            clickable: true,
            bulletClass: 'my-bullet',//需设置.my-bullet样式
            bulletActiveClass: 'my-bullet-active',
        },
    // 如果需要前进后退按钮
        navigation: {
            nextEl: '#transaction-box .swiper-button-next',
            prevEl: '#transaction-box .swiper-button-prev',
        },
    });
    var mySwiper2 = new Swiper('#company-swiper', {
    // 如果需要分页器
        pagination: {
            el: '#company-swiper .swiper-pagination',
            clickable: true,
            bulletClass: 'my-bullet',//需设置.my-bullet样式
            bulletActiveClass: 'my-bullet-active',
        },
    // 如果需要前进后退按钮
        navigation: {
            nextEl: '#company-box .swiper-button-next',
            prevEl: '#company-box .swiper-button-prev',
        },
    });
    var mySwiper3 = new Swiper('#activity-box .swiper', {
    // 如果需要分页器
        pagination: {
            el: '#activity-box .swiper-pagination',
            clickable: true,
            bulletClass: 'my-bullet',//需设置.my-bullet样式
            bulletActiveClass: 'my-bullet-active',
        },
    // 如果需要前进后退按钮
        navigation: {
            nextEl: '#activity-box .swiper-button-next',
            prevEl: '#activity-box .swiper-button-prev',
        },
    })

    var mySwiper4 = new Swiper('#party-box .swiper', {
        // 如果需要分页器
            pagination: {
                el: '#party-swiper .swiper-pagination',
                clickable: true,
                bulletClass: 'my-bullet',//需设置.my-bullet样式
                bulletActiveClass: 'my-bullet-active',
            },
        // 如果需要前进后退按钮
            navigation: {
                nextEl: '#party-box .swiper-button-next',
                prevEl: '#party-box .swiper-button-prev',
            },
        });

    index = parseInt(index);
    var str = '';
    var size = '';

    if (category == 'mediaArticles') { //媒体报道
        var newArr = [];
        var mediaStr = []
        change2Array(mediaArticles, 4, newArr);
        var more = lang === 'en' ? 'More' : '了解更多';
        mediaStr = newArr.map(function (arr) {
            return '<div class="swiper-slide">' + arr.map(function (ar, ind) {
                var mediaArticlesUr = '';
                if (ar.link && ar.link.length > 0) {
                    mediaArticlesUr = ar.link
                } else {
                    mediaArticlesUr = '/newsDetail?nav=mediaNav&id=' + ar.id
                }
                return `<div  class="${ind == 0 ? 'active' : 'wrapper-bg'} ${ind == 0 ? '' : 'col-md-4'} ${'ind' + ind} media ${ind == 0 ? '' : 'no-hover'}">
                  <div class="wrapper-con">
                    <a target="_blank" href="${mediaArticlesUr}">
                      <img class="${ind == 0 ? '' : 'hoverImg gray'}" src=${minioUrl + ar.logo}>
                      <div class="wrapper-title">
                        ${ind == 0 ? '<div class="img"></div>' : ''}
                        <a target="_blank" href="${mediaArticlesUr}">
                          <div style="-webkit-box-orient: vertical" class="select-title ${lang === 'en'?'':''}">
                            ${ar.title}
                          </div>
                        </a>
                        ${ind == 0 ? 
                          `<a class="my-btn"  target="_blank" href="${mediaArticlesUr}">${more}</a>` 
                          : ''}
                      </div>
                    </a>
                  </div>
                </div>`
            }).join('') + '</div>'
        }).join('');
        $('#media-swiper .swiper-wrapper').html(mediaStr);

        var animateClass = 'fadeInUp animated';
        $('.media').hover(
      function () {
          $(this).find('.hover').show();
          $(this).find('.hover').addClass(animateClass);
      },
      function () {
          $(this).find('.hover').hide();
          $(this).find('.hover').removeClass(animateClass);
      }
    );

    } else if (category == 'transactionArticles') { //交易报道
        var transactionNewArr = [];
        var transactionStr = '';
        change2Array(transactionArticles, 3, transactionNewArr);
        transactionStr = transactionNewArr.map(function (arr) {
            var transactionTempStr = '';
            return '<div class="swiper-slide">' +
        arr.map(function (ar, ind) {
            var transactionUrl = '';
            if (ar.link.length > 0) {
                transactionUrl = ar.link
            } else {
                transactionUrl = '/newsDetail?nav=transactionNav&id=' + ar.id
            }
            return '<a target="_blank" href="' + transactionUrl + '"><div class="col-md-4 col-transaction ' + 'ind' + ind + ' "><div class="transaction"><div class="no-hover">' +
            '<img class="w-p100 hoverImg gray" src=' + `${minioUrl + ar.logo}` + '>' +
            '<div class="bottom"><div style="-webkit-box-orient: vertical"  class="bottom-con">' + ar.title + '</div></div> </div>' +
            '</div> </div></a>';
        }).join('') +
        '</div>'
        }).join('');
        $('#transaction-swiper .swiper-wrapper').html(transactionStr);
        var animateClass = 'fadeInUp animated';
        $('.transaction').hover(function () {

            $(this).find('.hover').show();
            $(this).find('.hover').addClass(animateClass);
        }, function () {

            $(this).find('.hover').hide();
            $(this).find('.hover').removeClass(animateClass);
        });

    } else if (category == 'companyArticles') { //公司报道
        var newArr = [];
        var companyStr=[]
        change2Array(companyArticles, 4, newArr);
        var more = lang === 'en' ? 'More' : '了解更多';
        companyStr = newArr.map(function (arr) {
            return '<div class="swiper-slide">' + arr.map(function (ar, ind) {
                var companyUrl = '';
                if (ar.link && ar.link.length > 0) {
                    companyUrl = ar.link
                } else {
                    companyUrl = '/newsDetail?nav=companyNav&id=' + ar.id
                }
                return `<div  class="${ind == 0 ? 'active' : 'wrapper-bg'} ${ind == 0 ? '' : 'col-md-4'} ${'ind' + ind} media ${ind == 0 ? '' : 'no-hover'}">
                  <div class="wrapper-con">
                    <a target="_blank" href="${companyUrl}">
                      <img class="${ind == 0 ? '' : 'hoverImg gray'}" src=${minioUrl +ar.logo}>
                      <div class="wrapper-title">
                        ${ind == 0 ? '<div class="img"></div>' : ''}
                        <a target="_blank" href="${companyUrl}">
                          <div style="-webkit-box-orient: vertical" class="select-title ${lang === 'en'?'':''}">
                            ${ar.title}
                          </div>
                        </a>
                        ${ind == 0 ? 
                          `<a class="my-btn"  target="_blank" href="${companyUrl}">${more}</a>` 
                          : ''}
                      </div>
                    </a>
                  </div>
              </div>`
            }).join('') + '</div>'
        }).join('');
        $('#company-swiper .swiper-wrapper').html(companyStr);

        var animateClass = 'fadeInUp animated';
        $('.company').hover(function () {

            $(this).find('.hover').show();
            $(this).find('.hover').addClass(animateClass);
        }, function () {

            $(this).find('.hover').hide();
            $(this).find('.hover').removeClass(animateClass);
        });

    } else if (category == 'activityArticles') { //活动报道
        var activityNewArr = [];
        var activityStr = '';
        change2Array(activityArticles, 4, activityNewArr);
        var more = lang === 'en' ? 'More' : '了解更多';
        activityStr = activityNewArr.map(function (arr) {
            return '<div class="swiper-slide">' + arr.map(function (ar, ind) {
                var companyUrl = '';
                if (ar.link && ar.link.length > 0) {
                    companyUrl = ar.link
                } else {
                    companyUrl = '/newsDetail?nav=activityNav&id=' + ar.id
                }
                return `<div  class="${ind == 0 ? 'active' : 'wrapper-bg'} ${ind == 0 ? '' : 'col-md-4'} ${'ind' + ind} media ${ind == 0 ? '' : 'no-hover'}">
                  <div class="wrapper-con">
                    <a target="_blank" href="${companyUrl}">
                      <img class="${ind == 0 ? '' : 'hoverImg gray'}" src=${minioUrl +ar.logo}>
                      <div class="wrapper-title">
                        ${ind == 0 ? '<div class="img"></div>' : ''}
                        <a target="_blank" href="${companyUrl}">
                          <div style="-webkit-box-orient: vertical" class="select-title ${lang === 'en'?'':''}">
                            ${ar.title}
                          </div>
                        </a>
                        ${ind == 0 ? 
                          `<a class="my-btn"  target="_blank" href="${companyUrl}">${more}</a>` 
                          : ''}
                      </div>
                    </a>
                  </div>
              </div>`
            }).join('') + '</div>'
        }).join('');
      
        $('#row-activity .swiper-wrapper').html(activityStr);
        var animateClass = 'fadeInUp animated';
        $('.company').hover(function () {

            $(this).find('.hover').show();
            $(this).find('.hover').addClass(animateClass);
        }, function () {

            $(this).find('.hover').hide();
            $(this).find('.hover').removeClass(animateClass);
        });

      
    } else if (category == 'partyArticles') { //党建动态
    

        var partyArticlesArr = [];
        var partyStr = '';
        change2Array(partyArticles, 3, partyArticlesArr);
        partyStr = partyArticlesArr.map(function (arr) {
            return '<div class="swiper-slide">' +
        arr.map(function (ar, ind) {
            var transactionUrl = '';
            if (ar.link.length > 0) {
                transactionUrl = ar.link
            } else {
                transactionUrl = '/newsDetail?nav=partyNav&id=' + ar.id
            }
            return '<a target="_blank" href="' + transactionUrl + '"><div class="col-md-4 col-transaction ' + 'ind' + ind + ' "><div class="transaction"><div class="no-hover">' +
            '<img class="w-p100 hoverImg gray" src=' + `${formatNoneOssUrl(ar.logo, minioUrl)}` + '>' +
            '<div class="bottom"><div style="-webkit-box-orient: vertical"  class="bottom-con">' + ar.title + '</div></div> </div>' +
            '</div> </div></a>';
        }).join('') +
        '</div>'
        }).join('');
        $('#party-swiper .swiper-wrapper').html(partyStr);
        var animateClass = 'fadeInUp animated';
        $('.transaction').hover(function () {

            $(this).find('.hover').show();
            $(this).find('.hover').addClass(animateClass);
        }, function () {

            $(this).find('.hover').hide();
            $(this).find('.hover').removeClass(animateClass);
        });

    }
  //翻页点击
    $('.item').click(function () {
        var index = $(this).attr('index');
        var category = $(this).parent('.inner').attr('category');
        $(this).parents('.inner').find('.active').removeClass('active');
        $(this).addClass('active');
        setArticles(category, index);
    });

  //图片灰色处理
    $('.hoverImg').hover(function () {
        $(this).removeClass('gray');
    }, function () {
        $(this).addClass('gray');
    })
}

//初始 inner
function getInnerStr(page, pageSize) {
    var count = Math.ceil(page / pageSize);
    var str = '';
    for (var i = 0; i < count; i++) {
        if (i == 0) {
            str += '<div class="item active" index=' + i + '></div>';
        } else if (i > 0 && i < 5) {
            str += '<div class="item" index=' + i + '></div>';
        }
    }
    return str;
}

//列表模式 获取搜索列表
var pageNo = 0;

function getArticlesList(type) {
  // 添加的判断是点击上面的位置切换title的时候将当前的位置的页数置为零
    if (type) {
        pageNo = 0;
    }
  // console.log('现在的pageNo是' + pageNo);
    var api = common.getAPI();
    var ajaxUrl = api + 'v1/china/article';
    var type = '';
    if (newsNav == 'mediaNav') {
        type = 'news-reports';
    } else if (newsNav == 'transactionNav') {
        type = 'transactions';
    } else if (newsNav == 'companyNav') {
        type = 'company-news';
    } else if (newsNav == 'activityNav') {
        type = 'events';
    } else if (newsNav == 'partyNav') {
        type = 'party-building-section'
    }

    $.ajax({
        url: ajaxUrl,
        type: 'get',
        dataType: 'json',
        data: {
            search: $('#search').val(),
            type: type,
            pageSize: '10',
            pageNo: pageNo,
            lang: lang === 'en' ? 'en' : 'zh',
        },
        success: function (data) {
            if (data.status) {
                var str = '';
                var listResult = data.result;
                if (listResult.length > 0) {
                    var pages = data.pages;
                    var pageArray = countPages(pageNo * 1 + 1, pages);
                    setPage(pageArray, pages);
                    $('#page-box').show();
                    var newstype = common.getNewsType(type);
                    common.formatDate();
                    for (var i = 0; i < listResult.length; i++) {
                        var date = new Date(listResult[i].publish_time);
                        var link = listResult[i].link;
                        if (link == undefined) {
                            link = '';
                        }
                        str +=
              '<div class="list">' +
              '<div class="left">' +
              '<div class="calendar">' +
              '<p class="date">' +
              date.Format('yyyy-MM') +
              '</p>' +
              '<p class="day">' +
              date.getDate() +
              '</p>' +
              '</div>' +
              '</div>' +
              ' <div class="right">' +
              '  <h3 class="tit">' +
              '<a href=' +
              (link.length > 0
                ? link + ' target="_blank"'
                : '/newsDetail?nav=' +
                newsNav +
                '&id=' +
                listResult[i].id +
                '') +
              '>' +
              listResult[i].title +
              '</a>' +
              '</h3>' +
              ' <div class="btn-box">';
                        if (link.length > 0) {
                            str +=
                '<a class="my-btn2" href=' +
                link +
                ' target="_blank" class="a checkDetail" >' +
                newstype +
                '</a>';
                        } else {
                            str +=
                '<a class="my-btn2" href="/newsDetail?nav=' +
                newsNav +
                '&id=' +
                listResult[i].id +
                '"  >' +
                newstype +
                '</a>';
                        }
                        str +=
              '</div>' +
              ' <div class="text">' +
              listResult[i].summary +
              '</div>' +
              '<div class="list-btn">';

                        if (link.length > 0) {
                            str +=
                '<a href=' +
                link +
                ' target="_blank" class="a checkDetail" >' +
                more +
                '</a>';
                        } else {
                            str +=
                '<a href="/newsDetail?nav=' +
                newsNav +
                '&id=' +
                listResult[i].id +
                '" target="_blank" class="a checkDetail" >' +
                more +
                '</a>';
                        }
                        str += '</div></div></div>';
                    }
                } else {
                    str =
            '<div class="list list-empty">' +
            '<div class="right">' +
            '<div class="empty-box">' +
            '<div class="empty-bg"></div>' +
            ' <div class="empty-text">找不到你想要的内容，换关键词试试 </div>' +
            '</div>' +
            '</div>' +
            '</div>';
                    $('#page-box').hide();
                }
                $('#list-con').html(str);
            }
        },
        error: function (msg) {
            console.log(msg);
        },
    });
}
//列表模式 分页计算
function countPages(page, total) {
    if (total == 1) {
        var array = [1];
        return array;
    } else {
        var str = page;
        for (var i = 1; i <= 3; i++) {
            if (page - i > 1) {
                str = page - i + ' ' + str;
            }

            if (page + i < total) {
                str = str + ' ' + (page + i);
            }
        }

        if (page - 3 > 1) {
            str = '... ' + str;
        }

        if (page > 1) {
            str = 1 + ' ' + str;
        }

        if (page + 3 < total) {
            str = str + ' ellipsis';
        }

        if (page < total) {
            str = str + ' ' + total;
        }
        return str.split(' ');
    }
}

//列表模式 分页加载
function setPage(pageArray, pages) {
    var pageStr =
    '<a index="1" class="page-item changePage">首页</a><a index="prev" class="page-item  changePage">上一页</a><p class="num-box">';
    for (var x = 0; x < pageArray.length; x++) {
        if (pageNo == pageArray[x] * 1 - 1) {
            pageStr +=
        '<a index=' +
        pageArray[x] +
        ' class="num active changePage">' +
        pageArray[x] +
        '</a>';
        } else if (pageArray[x] == 'ellipsis') {
            pageStr += '<a  class="num">...</a>';
        } else {
            pageStr +=
        '<a index=' +
        pageArray[x] +
        ' class="num changePage">' +
        pageArray[x] +
        '</a>';
        }
    }
    pageStr +=
    '</p>' +
    '<a index="next" class="page-item changePage">下一页</a>' +
    '<a index=' +
    pages +
    ' class="page-item changePage">末页</a>' +
    ' <span class="page-item">共' +
    pages +
    '页</span>';
    $('#page-box').html(pageStr);
    $('.changePage').click(function () {
        var index = $(this).attr('index');
        if (index == 'next') {
            if (pageNo === pages || pageNo+1 === pages) {
                return;
            } else if (pageNo < pages) {
                pageNo += 1;
            }
        } else if (index == 'prev') {
            if (pageNo == 0) {
                return;
            } else if (pageNo > 0) {
                pageNo = pageNo * 1 - 1;
            }
        } else {
            pageNo = index * 1 - 1;
        }
        getArticlesList();
    });
}



// WEBPACK FOOTER //
// ./src/news.js